export const getScrollMetrics = (scrollContainer: HTMLElement, isVerticalScroll: boolean) => {
    if (!scrollContainer) {
        return {
            scrollPosition: 0,
            viewportSize: 0,
            contentSize: 0,
        };
    }

    return {
        scrollPosition: isVerticalScroll ? scrollContainer.scrollTop : scrollContainer.scrollLeft,
        viewportSize: isVerticalScroll ? scrollContainer.clientHeight : scrollContainer.clientWidth,
        contentSize: isVerticalScroll ? scrollContainer.scrollHeight : scrollContainer.scrollWidth,
    };
};
